import { createStore } from 'vuex';
import index from './modules'

const store = createStore({
  modules: {
    index
  }
});

export default store;
